import { FacilityDocumentPickerItem } from "components/FacilityDocumentPicker";
import { CaSections } from "encamp-shared/src/hmbp/sections";
import { DynamicField } from "generated-graphql/graphql";

export enum DocumentOption {
  Upload = "Upload",
  PublicInternetURL = "Public Internet URL",
  ProvidedToRegulator = "Provided to Regulator",
  ProvideElsewhere = "Provided Elsewhere",
  Exempt = "Exempt",
  StoredAtFacility = "Stored at Facility",
}

export enum DialogStep {
  DocumentOptions = "document-options",
  Upload = "upload",
  PublicInternetURL = "public-internet-url",
  ProvidedToRegulator = "provided-to-regulator",
  ProvidedElsewhere = "provided-elsewhere",
  Exempt = "exempt",
  StoredAtFacility = "stored-at-facility",
}

export type FormState = {
  documentOption: DocumentOption | null;
  publicInternetURL: string | null;
  providedToRegulator: Date | null;
  suppliedIn: CaSections | null;
  suppliedInExplanation: string | null;
  exemptExplanation: string | null;
  storedAtFacilityCersId: string | null;
  documentIds: string[];
  upload?: UploadFile[];
};

export type FormSubmitData = {
  documentUploads: UploadFile[];
  stateFields: DynamicField[];
};

export type UploadFile = {
  document?: FacilityDocumentPickerItem;
  file?: File;
  extension: string;
  previewURL: string | null;
  keepOriginalFilename?: boolean;
};

export type FieldMapping = Record<string, { fieldKey: string; value: any }>;
